import { render, staticRenderFns } from "./PermissionMatrix.vue?vue&type=template&id=b8e4c896&scoped=true&"
import script from "./PermissionMatrix.vue?vue&type=script&lang=js&"
export * from "./PermissionMatrix.vue?vue&type=script&lang=js&"
import style0 from "./PermissionMatrix.vue?vue&type=style&index=0&id=b8e4c896&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e4c896",
  null
  
)

export default component.exports